/**
 * @file resourceScopeUtils.js
 * @description Provides resource scope defaults for authenticated users.
 */

import { ResourceScope } from '../../utils/data/enums';

export function normalizeUserType(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const normalizedValue = Number(value);
    return Number.isNaN(normalizedValue) ? null : normalizedValue;
}

export function getResourceScopesForUser({
    isMultiTenantTrainingView = false,
    isGlobalResourceUser = false,
    isIndividualUser = false,
    isIndividualResourceView = false,
    isClientAdminUser = false,
    hasIndividualId = false,
    canSwitchToIndividualView = false,
    shouldForceClientAdminScope = false,
}) {
    if (isIndividualUser || isIndividualResourceView) {
        return [ResourceScope.Individual];
    }

    if (isMultiTenantTrainingView) {
        return isGlobalResourceUser
            ? [ResourceScope.Global, ResourceScope.Agency]
            : [ResourceScope.Agency];
    }

    const canUseClientAdminScope =
        shouldForceClientAdminScope ||
        isClientAdminUser ||
        canSwitchToIndividualView;

    if (canUseClientAdminScope) {
        return [
            ResourceScope.ClientAdmin,
            ...(hasIndividualId || canSwitchToIndividualView
                ? [ResourceScope.Individual]
                : []),
        ];
    }

    if (hasIndividualId) {
        return [ResourceScope.Individual];
    }

    return [];
}
